import { UserActivation } from "@/models/userActivations";
import axios, { AxiosResponse } from "axios";
import { Institution } from "../models/institution-model";
import { UserApiData } from "../models/user-model";
import { postApiLogin } from "@/api/axios/postApiLogin";

import { configService, ObjectFromEnvelope } from "./config.service";
class LoginService {
  async sendRecoveryLink(username: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      axios
        .post(configService.APIUrl("send_password_activation_link.json"), {
          username: username
        })
        .then(() => {
          resolve(true);
        })
        .catch((error) => {
          const e: any = error.response?.data;
          reject(e);
        });
    });
  }

  async KeepAlive(): Promise<boolean> {
    return new Promise((resolve) => {
      axios
        .get(configService.APIUrl("keep_session_alive"))
        .then(() => {
          resolve(true);
        })
        .catch(() => {
          resolve(false);
        });
    });
  }

  async Logout(): Promise<boolean> {
    return new Promise((resolve) => {
      axios
        .post(configService.APIUrl("logout.json"))
        .then(() => {
          resolve(true);
        })
        .catch(() => {
          resolve(false);
        });
    });
  }

  async LoginBasic(username: string, password: string): Promise<UserApiData> {
    try {
      const response = await postApiLogin({
        username: username,
        password: password
      });
      return response.data as UserApiData;
    } catch (error: any) {
      const e: any = error.response?.data;
      throw e;
    }
  }

  async LoginOpenId(token: string): Promise<UserApiData> {
    return new Promise((resolve, reject) => {
      axios
        .post(
          configService.APIUrl("login_openid.json"),
          {},
          {
            headers: {
              AUTHORIZATION: "Bearer " + token
            }
          }
        )
        .then((response: AxiosResponse) => {
          resolve(response.data.data as UserApiData);
        })
        .catch((error) => {
          const e: any = error.response?.data;
          reject(e);
        });
    });
  }

  async activateNewUser(obj: {
    ssn: string;
    token: string;
    accessToken: string;
    postalCode: number;
  }): Promise<void> {
    return new Promise((resolve, reject) => {
      axios
        .post(
          configService.APIUrl("user_activations/activate_new_user.json"),
          { ssn: obj.ssn, token: obj.token, postal_code: obj.postalCode },
          {
            headers: {
              AUTHORIZATION: "Bearer " + obj.accessToken
            }
          }
        )
        .then(() => {
          resolve();
        })
        .catch((error) => {
          const e: any = error.response?.data;
          reject(e);
        });
    });
  }

  async createUserActivation(obj: { fullName: string; email: string }): Promise<void> {
    return new Promise((resolve, reject) => {
      axios
        .post(configService.APIUrl("user_activations.json"), {
          full_name: obj.fullName,
          email: obj.email
        })
        .then(() => {
          resolve();
        })
        .catch((error) => {
          const e: any = error.response?.data;
          reject(e);
        });
    });
  }

  async getInstitutionByToken(token: string): Promise<Institution> {
    return new Promise((resolve, reject) => {
      axios
        .get(configService.APIUrl("user_activations/activate_new_user.json?token=" + token))
        .then((response: AxiosResponse) => {
          resolve(Institution.fromJSON(ObjectFromEnvelope<Institution>(response.data)));
        })
        .catch((error) => {
          const e: any = error.response?.data;
          reject(e);
        });
    });
  }

  async setLocale(locale: string): Promise<void> {
    await axios.put(configService.APIUrl("set_locale.json"), { locale });
  }

  async getActivations(): Promise<UserActivation[] | null> {
    return new Promise((resolve, reject) => {
      axios
        .get(configService.APIUrl("user_activations.json"))
        .then((response: AxiosResponse) => {
          resolve(UserActivation.fromJSONArray(ObjectFromEnvelope(response.data)));
        })
        .catch((error) => {
          const e: any = error.response?.data;
          reject(e);
        });
    });
  }
}

// export a singleton instance in the global namespace
export const loginService: LoginService = new LoginService();
